/**
 * 売上品目単位
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/sales_item_units`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
    },
  }
}
const sales_item_unit = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 売上品目単位 一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { page, limit }) {
      dispatch('saveCondition', { limit: limit })
      const params = { 
        page: page, 
        limit: limit
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_SALES_ITEM_UNIT_PAGINATION, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { limit }) {
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = {
        limit: _limit,
      }
      commit(types.DRIVER_SALES_ITEM_UNIT_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_SALES_ITEM_UNIT_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_SALES_ITEM_UNIT_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_SALES_ITEM_UNIT_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_SALES_ITEM_UNIT_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_SALES_ITEM_UNIT_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_SALES_ITEM_UNIT_CONDITION] (state, { params }) {
      state.condition.limit = params.limit
    },
  },
}

export default sales_item_unit
